import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "exportBtnBox" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("合同异常提醒")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("签订")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("续签")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重新签订")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("忽略")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("查看")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import router from '@/router/index'
import { signTimesMap, categoryMap } from '@/views/typeMapping/HumanReousces'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  emits: ['singContract'],
  setup(__props, { emit }) {

const {
  // 获取异常信息列表
  'POST/labor_contracts/exception/list': exceptionListApi,
  // 删除异常信息
  'DELETE/labor_contracts/exception/{id}': delApi,
  // 查看合同
  'POST/labor_contracts/list': listApi,
  // 获取审批状态
  'GET/labor_contracts/drop_list/approval_status': approval_statusApi,
  // 获取有权限查看的异常个数
  'GET/labor_contracts/exception/count': countApi,
} = Api


const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(exceptionListApi)

let statusMap: any = reactive({})
let count: any = ref(0)
onBeforeMount(() => {
  // 获取合同状态类型
  approval_statusApi().then((rep: any) => {
    Object.assign(statusMap, rep)
  })
  // 获取个数
  countApi().then((rep: any) => {
    count.value = rep.count

  })
})

const isShowException = ref<boolean>(false)
const showList = ref<boolean>(false)
// 添加
const getExceptionHandle = () => {
  isShowException.value = true
  fetchData()
}

// 签订
const singHandle = (row: {userId: number}) => {
  isShowException.value = false
  router.push({
    name: 'laborContract',
    query: {
      type: '3',
      id: row.userId
    }
  })
  emit('singContract', row.userId)
}

// 续签(需填充历史数据)
const renewHandle = (row) => {
  isShowException.value = false
  router.push({
    name: 'laborContract',
    query: {
      type: '4',
      id: row.userId
    }
  })
  emit('renewHandle', row.userId)
}

// 忽略
const delHandle = (row: {id: number}) => {
  ElMessageBox.confirm('请确认是否忽略', '提示', {
    type: 'warning'
  }).then(() => {
    return delApi({id: row.id})
  }).then(() => {
    getExceptionHandle()
    ElMessage.info('已忽略')
  })
}

// 查看
const contractList = ref([])
const showListHandle = (row: any) => {
  MI_identify.value = true
  listApi({
    userId: row.userId,
    page: 1,
    size: 100,
  }).then((rep: any) => {
    contractList.value = rep.data
    showList.value = true
  }).finally(() => {
    MI_identify.value = false
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_component_el_badge, {
      value: _unref(count),
      type: "danger"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (getExceptionHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowException.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isShowException).value = $event)),
      title: "员工合同异常提醒"
    }, {
      default: _withCtx(() => [
        _createElementVNode("main", null, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: _unref(MI_tableData),
            border: "",
            "max-height": "700px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "realName",
                label: "姓名"
              }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(`${row.realName}(${row.alias})`), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "endDate",
                label: "合同到期时间"
              }),
              _createVNode(_component_el_table_column, {
                prop: "type",
                label: "异常情况"
              }),
              _createVNode(_component_el_table_column, { label: "操作" }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_space, null, {
                    default: _withCtx(() => [
                      (row.type === '无合同')
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 0,
                            type: "primary",
                            onClick: ($event: any) => (singHandle(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (['合同即将到期', '合同已过期'].includes(row.type))
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 1,
                            type: "primary",
                            onClick: ($event: any) => (singHandle(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (['全职转兼职', '公司变更'].includes(row.type))
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 2,
                            type: "info",
                            onClick: ($event: any) => (renewHandle(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (['转正', '岗位变更', '离职', '合同即将到期', '合同已过期'].includes(row.type))
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 3,
                            type: "info",
                            onClick: ($event: any) => (delHandle(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (['离职但合同未失效', '多个合同'].includes(row.type))
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 4,
                            type: "info",
                            onClick: ($event: any) => (showListHandle(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _unref(MI_identify)]
          ]),
          _createVNode(_component_el_pagination, {
            small: "",
            style: {"float":"none"},
            total: _unref(MI_total),
            currentPage: _unref(page),
            "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
            "page-size": _unref(size),
            "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
            class: "mt-10",
            "page-sizes": [10, 30, 50, 100, 200, 600],
            layout: "sizes, prev, pager, next, total, jumper",
            onCurrentChange: _unref(MI_pageChange),
            onSizeChange: _unref(MI_sizeChange)
          }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: showList.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showList).value = $event)),
      title: "合同列表"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: contractList.value,
          border: "",
          "max-height": "700px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "合同编号",
              prop: "no",
              "show-overflow-tooltip": "",
              width: "100",
              fixed: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "合同状态",
              prop: "approvalStatus",
              "show-overflow-tooltip": "",
              width: "130"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_unref(statusMap)[row.approvalStatus]), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "合同签订次数",
              prop: "signTimes",
              "show-overflow-tooltip": "",
              width: "120",
              formatter: (row) => _unref(signTimesMap)('map')[row.signTimes]
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "合同类型",
              prop: "category",
              "show-overflow-tooltip": "",
              width: "100",
              formatter: (row) => _unref(categoryMap)('map')[row.category]
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "员工姓名",
              prop: "",
              "show-overflow-tooltip": "",
              width: "120"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(`${row.employeeName}(${row.employeeAlias})`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "劳动归属公司",
              prop: "companyName",
              "show-overflow-tooltip": "",
              width: "120"
            }),
            _createVNode(_component_el_table_column, {
              label: "归属团队",
              prop: "orgName",
              "show-overflow-tooltip": "",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              label: "劳动起",
              prop: "startDate",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "劳动止",
              prop: "endDate",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "劳动合同经办人",
              prop: "",
              "show-overflow-tooltip": "",
              width: "135"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(`${row.operatorName}(${row.operatorAlias})`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "合伙人",
              prop: "",
              "show-overflow-tooltip": "",
              width: "100"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(`${row.leaderName}(${row.leaderAlias})`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "领导审核日期",
              prop: "leaderAuditorDate",
              "show-overflow-tooltip": "",
              width: "120"
            }),
            _createVNode(_component_el_table_column, {
              label: "薪酬负责人",
              prop: "",
              "show-overflow-tooltip": "",
              width: "110"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(`${row.rewardName}(${row.rewardAlias})`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "薪酬负责人审核日期",
              prop: "rewardAuditorDate",
              "show-overflow-tooltip": "",
              width: "170"
            }),
            _createVNode(_component_el_table_column, {
              label: "管理者",
              prop: "",
              "show-overflow-tooltip": "",
              width: "110"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(`${row.mangerName}(${row.mangerAlias})`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "入职日期",
              prop: "hireDate",
              "show-overflow-tooltip": "",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              label: "离职日期",
              prop: "leaveDate",
              "show-overflow-tooltip": "",
              width: "100"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})